
function Profile(){
    return (
        <section id='profile'>
            <div className="container">
                <h1>About me</h1>
                <div className="profile-content">
                    <div className="profile-left">
                        <h2>Second-year CS student at ESI Algiers</h2>
                        <p>
                            I design and build practical digital products at the intersection
                            of AI, data, and web engineering. I enjoy transforming complex
                            requirements into clean interfaces and reliable systems.
                        </p>
                        <div className="profile-meta">
                            <a className='link' href='https://www.esi.dz/' target="_blank" rel="noreferrer">Higher National School of Computer Science (ESI)</a>
                            <span>Setif / Algiers, Algeria</span>
                            <span>Arabic, French, English , German </span>
                        </div>
                    </div>
                    <div className="profile-right">
                        <img src="/pdf.jpeg" alt='Tadj Zerroug profile' className="pdf"/>
                    </div>
                </div>
                <div className="profile-bottom">
                    <a
                        className="download-cv-btn"
                        href="mailto:ot_zerroug@esi.dz"
                    >
                        Open to internships and collaborations
                    </a>
                </div>
            </div>
        </section>
    )
}


export default Profile ; 
